import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import EventCharts from '@components/machines/components/eventsChart';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { productionBatchStatistics } from '@reducers/statistics';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import Paid from '@components/ncFiles/components/paid';

interface BatchDetailsNCFilePerformancePaidProps {}

const BatchDetailsNCFilePerformancePaidComponent: FC<BatchDetailsNCFilePerformancePaidProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <Paid {...props} />} />
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFilePerformancePaid = connect(null, {
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFilePerformancePaidComponent);

export { BatchDetailsNCFilePerformancePaid };
